<template>
  <div class="attachment">
    <div v-if="showOutcomes" class="outcome-wrapper">
      <label class="form-control-label">Outcomes:</label>
      <div v-for="outcome in currentNode.outcomes" :key="outcome.id" class="form-group">
        <div class="input-with-icon">
          <input @input="updateOutcome($event.target.value, outcome.id)" :value="outcome.text" type="text" class="form-control form-control-sm">
          <b-button @click="deleteOutcome(outcome.id)" size="sm" variant="danger"><icon name="trash" /></b-button>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="form-control-label">Add outcome</label>
      <div class="input-with-icon">
        <input v-model="newOutcome" type="text" class="form-control form-control-sm">
        <b-button @click="addOutcome" size="sm" variant="success"><icon name="plus" /></b-button>
      </div>
    </div>
    
    <div class="form-group">
      <label class="form-control-label">Assigned To:</label>
      <select @input="updateUser($event.target.value)" :value="usersSelect[0].label" class="form-control form-control-sm">
        <option v-for="user in usersSelect" :key="user.id">{{ user.label }}</option>
      </select>
    </div>
    
    <div class="form-group">
      <label class="form-control-label">Image:</label>
      <file-upload 
        :disable-preview="true"
        :file-name="'Load Image'"
        :image-class="'preview'"
        placeholder="Load Image"
        :input-class="'form-control'"
        @load="loadImage"
      />
    </div>
    <div v-if="currentNode.attachment.image" class="mb-4">
      <div class="form-group">
        <label class="form-control-label">Image height:</label>
        <input v-model="height" type="text" class="form-control form-control-sm">
      </div>

      <div class="form-group">
        <label class="form-control-label">Image width:</label>
        <input v-model="width" type="text" class="form-control form-control-sm">
      </div>
      <b-button-group>
        <b-button @click.prevent="updateImageSize" variant="success" size="sm">Update Image Size</b-button>
        <b-button @click.prevent="deleteImage" size="sm" variant="danger">Delete Image</b-button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
import FileUpload from 'vue-base64-file-upload'
import { mapState } from 'vuex'
import { formBase, outcomeMixin } from './mixins'

export default {
  mixins: [formBase, outcomeMixin],
  data() {
    return {
      width: 400,
      height: 400,
    }
  },
  components: {
    FileUpload
  },
  computed: {
    ...mapState([
      'userList'
    ]),
    usersSelect () {
      const userList = []

      for (let user of this.userList) {
        userList.push({label: user.email || user.uid, id: user.uid})
      }

      userList.push({label: 'All Users', id: '#general'})

      return userList
    }
  },
  methods: {
    loadImage(img) {
      let currentNode = Object.assign({}, this.currentNode)
      
      if (!currentNode.hasOwnProperty('attachment')) {
        currentNode['attachment'] = {}
      }
      
      if (img) { 
        currentNode.attachment['image'] = img
        currentNode.attachment['imgWidth'] = 400 
        currentNode.attachment['imgHeight'] = 400 
      }
      this.updateNode(currentNode)
      this.updateCounter()
    }, 
    deleteImage() {
      let currentNode = Object.assign({}, this.currentNode)

      if (currentNode.hasOwnProperty('attachment') && currentNode.attachment.image) {
        currentNode.attachment.image = null 
        currentNode.attachment.imgWidth = null 
        currentNode.attachment.imgHeight = null 
      }
      this.updateNode(currentNode)
      this.updateCounter()
    },
    updateUser(user) {
      let currentNode = Object.assign({}, this.currentNode)
      if (!currentNode.hasOwnProperty('attachment')) {
        currentNode['attachment'] = {}
      }
      if (user) { 
        currentNode.attachment['user'] = user
      }
      this.updateNode(currentNode)
    },
    updateImageSize() {
      let currentNode = Object.assign({}, this.currentNode)

      if (!currentNode.hasOwnProperty('attachment')) { 
        currentNode['attachment'] = {}
      }

      let width = parseInt(this.width),
      height = parseInt(this.height)

      if (isNaN(height) || isNaN(width) || width === null || height === null) return

      currentNode.attachment['imgHeight'] = height
      currentNode.attachment['imgWidth'] = width 
      this.updateNode(currentNode)
    } 
  },
  mounted() {
    if (this.currentNode.hasOwnProperty('attachment') && this.currentNode.attachment.imgWidth && this.currentNode.attachment.imgHeight) {
      this.width = this.currentNode.attachment.imgWidth
      this.height = this.currentNode.attachment.imgHeight
    }
  }
}
</script>

<style lang="scss" scoped>
  .hidden{
    visibility: hidden;
  }
  .input-with-icon{
    display: flex;
    align-items: center;
  }
</style>